import { Component, OnChanges, Input, Output, EventEmitter, ViewChild, OnDestroy, ViewChildren, QueryList, ChangeDetectorRef, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { processCompliance } from '../Models/processCompliance';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { SopDetail } from '../Models/SopDetail';
import { PhBhpFilterComponent } from '../ph-bhp-filter/ph-bhp-filter.component';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpPdfComplianceMultiFilterComponent } from '../ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { PhBhpBarChartComponent } from '../ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhpBhpChartExportComponent } from '../php-bhp-chart-export/php-bhp-chart-export.component';

@Component({
  selector: 'lib-ph-bhp-sop-process-compliance',
  templateUrl: './ph-bhp-sop-process-compliance.component.html',
  styleUrls: ['./ph-bhp-sop-process-compliance.component.css']
})
export class PhBhpSopProcessComplianceComponent implements OnInit, OnChanges, OnDestroy {
  private static readonly INITIAL_FIELDS = [
    { 'field': 'title', 'title': 'EVALUATION.TITLE', 'group': '' },
  ];
  pageTitle: string;
  textLegend: string;
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  compareCard = false;
  tempFilter;
  showCompareCard;
  singleCard;
  data;
  @Input() filterDetails = [];
  @Input() userData;
  @Input() isDesktop = true;
  @Output() childData = new EventEmitter();

  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;

  @ViewChild('exportTag', { static: true }) exportTag: PhpBhpChartExportComponent;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterComponent;
  @ViewChild('multiselect', { static: true }) multiselect: any;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;

  isAdjustableHeight = true;
  initFlag = true;
  sopIDs: Array<any> = [];
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  complianceType;
  pageInfo = {
    items: 'EVALUATION.SOPS',
    itemsPerPageLabel: 'EVALUATION.PER_PAGE.SOPS'
  };
  sopDetail: SopDetail[];
  userID;
  roleId;
  appName = "MHS";
  translationKeys: typeof TranslationKeys = TranslationKeys;
  filterIndices: number[] = [0];
  isEvaluationTable: boolean = true;
  multiSelectText: string = '';

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;
  evaluationLoaded: boolean = false;

  results:any = [];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  userFilters: any;
  sopFilters: any[] = [];

  constructor(
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService
  )
  {
    this.pageTitle = this.layoutService.translateText('DASHBOARD.PROCESS_COMPLIANCE');
    this.textLegend = this.layoutService.translateText("EVALUATION.PERCENT_COMPLIANCE");
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
  }

  ngOnInit(): void {

    this.userID = this.userData.userId;
    this.roleId = this.userData.roleName.roleId;

    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for(let i = 0; i < this.charts.length; i++){
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }
        this.pageTitle = this.layoutService.translateText('DASHBOARD.PROCESS_COMPLIANCE');
        this.compliance.complianceTitle = this.layoutService.translateText('DASHBOARD.PROCESS_COMPLIANCE');
        this.evaluate(true);
        this.layoutService.showLoader = false;
      }, 1000);
    });
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.evaluationService.getSOPDetails(this.userData.userId).subscribe((res: Array<SopDetail>) => {
      this.sopDetail = res;
      this.userHasFilter = false;
      this.sopDetail = this.sopDetail.sort((a, b) => this.compareSOPTitles(a, b));
      if (!this.isUserFilterSetted) {
        this.evaluationService.getUserHasSOPEvaluationFilter(this.userData.userId, 'Process compliance').subscribe((userHasFilter) => {
          this.isUserFilterSetted = true;


          if(userHasFilter){
            this.userHasFilter = true;
            this.userFilters = JSON.parse(userHasFilter.filterList);
            this.userFilters = this.userFilters.Filter;
            setTimeout(() => { this.initComponent(); });
          }else{
            this.userFilters = [];
            this.noDataFound = true;
            this.filters.get(0).showFilter(true);
            this.compliance.resultsLoader.next([{}]);
          }
        }, (error) => { }, () => { this.layoutService.showLoader = false; });
      } else {
        setTimeout(() => { this.initComponent(); });
      }
    });
  }

  initComponent() {

    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }


    if (this.userData) {
      for(let i = 0; i < this.charts.length; i++){
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title.text = this.textLegend;
      }

      // this.compliance.printChart = true;
      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';

      this.loadFiltersInfo();

      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, iniatilize?) {

    this.printConfig();

    this.data = {
      sopiDs: "",
      filter: [],
      isBenchMark: true,
      roleId: this.roleId
    };
    if (this.sopIDs.length == 0) {
      this.sopDetail.forEach((sop) => {
        this.data.sopiDs += sop.sopid + ","
      });
      this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    } else {
      this.sopIDs.forEach(element => {
        this.data.sopiDs += element.sopid + ",";
      });
      this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    }

    if(iniatilize){
      this.data.filter = this.userFilters;
    }else{
      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0
        };
        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filter.push(filterData);
        if(filterData.multiSelectName){
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.userHasFilter = true;
    if (getResults == true) {
      this.getProcessComplianceFilterDetails(this.userData.userId, this.data);
    } else if (getResults == false) {
      this.saveProcessComplianceFilterDetails(this.userData.userId, this.data);
    }

  }

  compareSOPTitles(a, b) {
    var aTitleTranslated = this.getSOPTranslation(a.title);
    var bTitleTranslated = this.getSOPTranslation(b.title);
    if (aTitleTranslated < bTitleTranslated) return -1;
    if (aTitleTranslated > bTitleTranslated) return 1;
    return 0;
  }

  getSOPTranslation(sopTrlID) {
    return this.layoutService.translateText(sopTrlID, '');
  }

  emitData(valve) {
    this.childData.emit(valve)
  }

  back() {
    this.filterDetails = [];
    this.emitData({ key: 'back' });
  }

  filterCompare() {
    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }

    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
      this.layoutService.showLoader = false;
    }, 500);
  }

  async loadFiltersInfo(){
    // need wait for the filter component to be initialized
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if(this.roleId==1){
          filterComponent.setSAFilter(filter, true);
        }else{
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID,'','', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.SubprofessionalCategoryID, true);
          if(filter.multiselect){
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }

      });
    }, 500);
  }

  printConfig() {
    if (this.sopIDs.length == 0) {
      this.compliance.SOPList = undefined;
      this.compliance.SOPName = this.layoutService.translateText("EVALUATION.All.SOP");;
    } else {
      this.compliance.SOPList = this.sopIDs;
      this.compliance.SOPName = undefined;
    }
  }

  showFilter(cardType) {
    let showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  saveProcessComplianceFilterDetails(userID, data) {
    this.complianceType = "Process compliance";
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.getProcessComplianceFilterDetails(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe(res => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText('EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT'));
    });
  }

  getProcessComplianceFilterDetails(userID, data) {
    this.complianceType = "Process compliance";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getProcessComplianceFilterDetails(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe((res: Array<processCompliance>) => {
      this.buildChart(res);
    })
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      let tempFilter = this.tempFilter;
      this.tempFilter = undefined;
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if(this.roleId==1){
          filterComponent.setSAFilter(filter, true);
        }else{
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '','', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.SubprofessionalCategoryID, true);
          if(filter.multiselect){
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    const colors = [
      "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300",
    ];

    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    this.results = res;

    let chart: PhBhpBarChartComponent;

    this.results = [];
    res.forEach(result => {
      if(result.processComplianceList.length > 0){
        let id = result.filterType || 'single';
        if(this.results.findIndex(r => r.id === id) === -1){
          this.results.push({ id, processComplianceList: [], gridData: [], fields: [...PhBhpSopProcessComplianceComponent.INITIAL_FIELDS], noDataFound: true });
        }
      }
    });

    // this.compliance.results = Object.assign([], this.results);
    this.compliance.resultsLoader.next(Object.assign([], this.results));

    // The timeout is necessary to give the chart QueryList time to load the component
    setTimeout(() => {
      console.log(res);


      res.forEach((processComplianceArray: any, index) => {
        let chartId = processComplianceArray.filterType || 'single';
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        // chartPdf = this.compliance.charts.get(chartIndex);
        let gridData:any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;

        let data = JSON.parse(JSON.stringify(chart.chartOptions));
        let dataSet = 0;
        let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');

        // Initialize only first iteration of the chart
        if(!data.setId){
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        dataSet = 0;
        data.series[data.nextIndex] = { data: [], name: [], dataOffset:[] , serieIndex: index};
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (!processComplianceArray.processComplianceList?.every(c=> c.noData)) {
          this.results[chartIndex].noDataFound = false;
          this.noDataFound = false;
          chart.noDataFound = false;
        }

        processComplianceArray.processComplianceList.forEach((processCompliance) => {
          let processComplianceItem = processCompliance;
          data.series[data.nextIndex].dataSetId = processComplianceItem.id;
          if (processComplianceItem.noData) {
            data.series[data.nextIndex].data.push("NODATA");
            data.series[data.nextIndex].dataOffset.push({id: processComplianceItem.title, setId: processComplianceItem.id, value: "NODATA"});
          } else {
            processCompliance.list.forEach((item) => {

            dataSet += item.totalObservations;
            data.series[data.nextIndex].data.push(item.processCompliancePercentage);
            data.series[data.nextIndex].dataOffset.push({id: item.title, setId: processComplianceItem.id, value: item.processCompliancePercentage});

            data.seriesIdentifier[data.nextIndex].push({id: item.title, setId: processComplianceItem.id});
            let title = this.layoutService.translateText(item.title);
            if(processComplianceItem.id >= 0 && processComplianceItem.name){
              title += " / " +this.layoutService.translateText(processComplianceItem.name);
            }
            title = title ? title : item.title;
            if (!data.categoryAxis.categories.includes(title)) {
              data.categoryAxis.categories.push(title);
              data.categoryAxis.categoryOffset.push({id: item.title, setId: processComplianceItem.id});
            }

            });
          }
        });

        let maxLength =  data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }


        data.series[data.nextIndex].name = [`${this.data.filter && this.data.filter[data.series[data.nextIndex].serieIndex] ? this.data.filter[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (data.series[data.nextIndex].serieIndex + 1)} - ${dataSet} ${dataSetsName}`];
        data.series[data.nextIndex].filterName = [`${this.data.filter && this.data.filter[data.series[data.nextIndex].serieIndex] ? this.data.filter[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (data.series[data.nextIndex].serieIndex + 1)}`];
        data.series[data.nextIndex].filterNum = data.series[data.nextIndex].serieIndex+1;


        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        gridData = Object.assign([], gridData);

        if (processComplianceArray && !processComplianceArray.isBenchMark) {
          processComplianceArray.processComplianceList.forEach(element => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if(processComplianceArray.filterType && processComplianceArray.filterType != 'single'){
              multiName = element.name;
              elementId = element.id;
              fields.push(
                { 'field': `totalCompliantObservationsforfilter${index + 1}_${elementId}`, 'title': 'EVALUATION.AMOUNT_COMPLIANT_OBSERVATIONS', 'group': `${this.data.filter && this.data.filter[index] ? this.data.filter[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName':multiName },
                { 'field': `totalObservationsforfilter${index + 1}_${elementId}`, 'title': 'EVALUATION.TOTAL_AMOUNT_OBSERVATIONS', 'group': `${this.data.filter && this.data.filter[index] ? this.data.filter[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`,'multiName':multiName },
              );
              element.list.forEach((item, i) => {
                let sop = gridData.find(gd => item.sopid === gd.sopid);
                if(!sop){
                  item[`totalObservationsforfilter${index + 1}_${element.id}`] = item['totalObservations'];
                  item[`totalCompliantObservationsforfilter${index + 1}_${element.id}`] = item['totalCompliantObservations'];
                  item.title = this.layoutService.translateText(item.title);
                  gridData.push(item);
                }else{
                  sop[`totalObservationsforfilter${index + 1}_${element.id}`] = item['totalObservations'];
                  sop[`totalCompliantObservationsforfilter${index + 1}_${element.id}`] = item['totalCompliantObservations'];
                }
              })
            }else{
              fields.push(
                { 'field': `totalCompliantObservationsforfilter${index + 1}`, 'title': 'EVALUATION.AMOUNT_COMPLIANT_OBSERVATIONS', 'group': `${this.data.filter && this.data.filter[index] ? this.data.filter[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
                { 'field': `totalObservationsforfilter${index + 1}`, 'title': 'EVALUATION.TOTAL_AMOUNT_OBSERVATIONS', 'group': `${this.data.filter && this.data.filter[index] ? this.data.filter[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
              );
              res2.forEach((item, i) => {
                let sop = gridData.find(gd => item.sopid === gd.sopid);
                if(!sop){
                  item[`totalObservationsforfilter${index + 1}`] = item['totalObservations'];
                  item[`totalCompliantObservationsforfilter${index + 1}`] = item['totalCompliantObservations'];
                  item.title = this.layoutService.translateText(item.title);
                  gridData.push(item);
                }else{
                  sop[`totalObservationsforfilter${index + 1}`] = item['totalObservations'];
                  sop[`totalCompliantObservationsforfilter${index + 1}`] = item['totalCompliantObservations'];
                }

              })

            }
          });
        }

        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].resultChart = chart;

        this.compliance.resultsLoader.next(Object.assign([], this.results));
        if (this.exportTag) {
          this.exportTag.results = Object.assign([], this.results);
        }

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if(complianceChart){
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 6, 2);
          this.compliance.setFilters(this.filters.toArray());
        }, 500);
      });

      this.changeLangProcessPage();

      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);

    }, 1000);

  }

  initializeFilters() {
    this.selectedSeries.clear();
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });
    this.evaluationService.getSOPEvaluationSeries(this.userData.userId, "Process compliance").subscribe((selectedSeries: any) => {
      this.layoutService.showLoader = false;
      if (!selectedSeries || selectedSeries.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(selectedSeries.selectedSeries);

      chartSeries.forEach(serie => {
        if(typeof serie === 'number'){
            this.charts.forEach((chart) => {
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
              chart.internalToggleSerie({ index: serie });
            });
        }else{
          let chart = this.charts.find(c => c.chartId === serie.chartId);
          if(!chart) return;
          chart.internalToggleSerie({ index: serie.series });
          this.compliance.toggleVisibility(chart.chartId, {index: serie.series });
          this.filters.forEach((filter, index) => {
            if (index != serie.series) return;
            if (filter.visible == undefined) filter.visible = true;
            filter.visible = !filter.visible;
          });
        }
      });
    }, (error) => {
    });
  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((processComplianceArray: any, index) => {
        if (index === 1) {
          if (processComplianceArray.isBenchMark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchMark);
    else
      return res;
  }

  shouldHideBenchmarkData() {
    return true;
    // return this.anyWardIsSelected();
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  changeLangProcessPage() {
    this.results.forEach((result, gridIndex) =>{
      result.gridData.forEach((value, index) => {
        if (value.title)
          this.results[gridIndex].gridData[index].title = this.layoutService.translateText(value.title);
          this.compliance.results[gridIndex].gridData[index].title = this.layoutService.translateText(value.title);
      });
    });
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
      this.userFilters.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;

    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  resetSOPFilter(isMultifilter: boolean = false) {
    this.multiselect.reset();
    this.sopIDs = [];
    if (isMultifilter) {
      this.layoutService.showLoader = true;
      this.evaluate(true);
    }
  }

  resetFilters() {
    this.resetSOPFilter();
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: "Process compliance",
      selectedSeries: null
    };

    this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => {
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });
  }

  originalFields: any[] = null;
  selectedSeries: Set<number> = new Set();

  onSeriesClick(serie: any) {

    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: "Process compliance",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  onMultiselectChange(event: Event) {
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }

  trackLoop(index: number, item: any) {
    return item;
  }
}


